import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { AiFillCloseCircle } from "react-icons/ai";

const EditExpenseModal = ({ isOpen, onClose, expense, changeListAgain }) => {
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({});

  const [load, setLoad] = useState(false);

  const [building, setBuilding] = useState([]);
  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);

  useEffect(() => {
    if (expense) {
      // Pre-fill form with existing data
      setValue("date", expense.date?.slice(0, 10));
      setValue("category", expense.category);
      setValue("amount", expense.amount);
      setValue("description", expense.description);
      setValue("buildingName", expense?.buildingName?._id);
    }
  }, [expense, setValue]);

  const closeModal = () => {
    onClose(); // Close the modal
    clearErrors();
    // reset(); // no need to reset the form as it is edit modal
  };

  const handleEditExpense = async (data) => {
    try {
      console.log(data);
      setLoad(true); // Start loading

      let config = {
        method: "put",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/expense/update-expense/${expense._id}`, // Update endpoint
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          toast.success(response.data.message);
          setLoad(false);
          changeListAgain();
          closeModal();
        })
        .catch((error) => {
          console.log(error);
          setLoad(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } catch (error) {
      console.error(error);
      setLoad(false);
      toast.error(error.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative h-[31rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        {/* Modal Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Edit Expense</h2>
          <AiFillCloseCircle
            onClick={closeModal}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        {/* Modal Content */}
        <form
          onSubmit={handleSubmit(handleEditExpense)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4"
        >
          <div className="col-span-1">
            <label className="block text-sm font-medium text-primaryTextColor">
              Building Name <span className="text-red-500">*</span>
            </label>

            <select
              className={`mt-1 block w-full border ${
                errors.buildingName ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm outline-none p-3`}
              {...register("buildingName", {
                required: "Building Name is required",
              })}
              onChange={(e) => {
                clearErrors("buildingName");
              }}
            >
              <option value={expense?.buildingName?._id} disabled selected>
                {expense?.buildingName?.nameBuilding}
              </option>
              {building.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.nameBuilding}
                </option>
              ))}
            </select>
            {errors.buildingName && (
              <span className="text-red-500 text-sm">
                {errors.buildingName.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="date"
              className="block text-sm font-medium text-gray-700"
            >
              Date
            </label>
            <input
              id="date"
              type="date"
              {...register("date", { required: "Date is required" })}
              className={`mt-1 p-3 block w-full border ${
                errors.date ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            />
            {errors.date && (
              <span className="text-red-500 text-sm">
                {errors.date.message}
              </span>
            )}
          </div>

          <div>
            <label
              htmlFor="category"
              className="block text-sm font-medium text-gray-700"
            >
              Category
            </label>
            <select
              id="category"
              {...register("category", { required: "Category is required" })}
              className={`mt-1 p-3 block w-full border ${
                errors.category ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            >
              <option value="" disabled>
                Select Category
              </option>
              <option value="Electricity Bill">Electricity Bill</option>
              <option value="Internet Bill">Internet Bill</option>
              <option value="Maintenance">Maintenance</option>
              {/* <option value="Security Return">Security Return</option> */}
              <option value="Employee Salary">Employee Salary</option>
              {/* <option value="Rent">Rent</option> */}
              <option value="Housekeeping">Housekeeping</option>
              <option value="Transport">Transport</option>
              <option value="Staff Advance">Staff Advance</option>
              <option value="Staff Salary">Staff Salary</option>
              <option value="Staff Food">Staff Food</option>
              <option value="Promotions">Promotions</option>
              <option value="Miscellaneous">Miscellaneous</option>
            </select>
            {errors.category && (
              <span className="text-red-500 text-sm">
                {errors.category.message}
              </span>
            )}
          </div>

          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Amount
            </label>
            <input
              type="number"
              id="amount"
              placeholder="Amount"
              {...register("amount", {
                required: "Amount is required",
                min: { value: 1, message: "Amount must be at least 1" },
              })}
              className={`mt-1 p-3 block w-full border ${
                errors.amount ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            />
            {errors.amount && (
              <span className="text-red-500 text-sm">
                {errors.amount.message}
              </span>
            )}
          </div>

          <div className="md:col-span-2">
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700"
            >
              Details
            </label>
            <textarea
              type="text"
              id="description"
              placeholder="Details"
              {...register("description", {
                required: "Details are required",
              })}
              className={`mt-1 p-3 block w-full border ${
                errors.description ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            />
            {errors.description && (
              <span className="text-red-500 text-sm">
                {errors.description.message}
              </span>
            )}
          </div>

          {/* Buttons */}
          <div className="sm:col-span-2 flex justify-between gap-6 mt-6 tracking-wide">
            <button
              onClick={closeModal}
              type="button"
              className="bg-white w-full border text-xs sm:text-lg hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor text-xs sm:text-lg hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
            >
              Save
            </button>
          </div>
        </form>
      </div>

      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span className="loader"></span>
        </div>
      )}
    </div>
  );
};

export default EditExpenseModal;
